import {LogLevel} from '../schema'

declare var process: {
  env: {
    [key: string]: string
  }
}

declare global {
  interface Window {
    getConfig: () => AppConfig
  }
}

export interface AppConfig {
  adyenClientId: string
  adyenEnvironment: string
  adyenPaymentsApiUrl: string
  cognitoRegion: string
  cognitoUserPoolId: string
  cognitoWebClientId: string
  environment: string
  googleAnalyticsId: string
  googleMapsApiKey: string
  ibeApiUrl: string
  ibeConfigCached: boolean
  ibeMemberRateCheck: boolean
  loggingApiUrl: string
  loggingEnabled: boolean
  loggingLevel: LogLevel
  metricsApiUrl: string
  metricsEnabled: boolean
  metricsNamespace: string
  reduxDevTools: boolean
}

/**
 * Gets the runtime application configuration.
 * @returns The application config
 */
export function getConfig(): AppConfig {
  return {
    adyenClientId: process.env.ADYEN_CLIENT_ID,
    adyenEnvironment: process.env.ADYEN_ENVIRONMENT,
    adyenPaymentsApiUrl: process.env.ADYEN_PAYMENTS_API_URL,
    cognitoRegion: process.env.COGNITO_REGION,
    cognitoUserPoolId: process.env.COGNITO_USER_POOL_ID,
    cognitoWebClientId: process.env.COGNITO_WEB_CLIENT_ID,
    environment: process.env.ENVIRONMENT,
    googleAnalyticsId: process.env.GOOGLE_ANALYTICS_ID,
    googleMapsApiKey: process.env.GOOGLE_MAPS_API_KEY,
    ibeApiUrl: process.env.IBE_API_URL,
    ibeConfigCached: process.env.IBE_CONFIG_CACHED === 'true',
    ibeMemberRateCheck: process.env.IBE_MEMBER_RATE_CHECK === 'true',
    loggingApiUrl: process.env.LOGGING_API_URL,
    loggingEnabled: process.env.LOGGING_ENABLED === 'true',
    loggingLevel: process.env.LOGGING_LEVEL as LogLevel,
    metricsApiUrl: process.env.METRICS_API_URL,
    metricsEnabled: process.env.METRICS_ENABLED === 'true',
    metricsNamespace: process.env.METRICS_NAMESPACE,
    reduxDevTools: process.env.REDUX_DEV_TOOLS === 'true'
  }
}

// expose the getConfig function globally
window.getConfig = getConfig
